function onScroll(event, eventHandler) {
  const listBoxNode = event.currentTarget;
  const { scrollTop, clientHeight, scrollHeight } = listBoxNode;
  if (Math.abs(scrollTop + clientHeight - scrollHeight) < 1) {
    eventHandler();
  }
}
export default onScroll;
